import { OntEthernetStatus } from '@ip6m/types';
import { Injectable } from '@nestjs/common';
import { HuaweiOidDB } from '../../core/services/huawei_oid.service';
import { SnmpService } from '../../core/services/snmp.service';
import { DeviceService } from './device.service';

@Injectable()
export class EthernetStatusService {
    
    constructor(
        private snmpService: SnmpService,
        private deviceS: DeviceService, 
        private oidDB: HuaweiOidDB
    ) {}
    
    async getOntEthState(ontSn: string): Promise<OntEthernetStatus> {

        const oids = this.oidDB.hwGponDeviceOntEthernetTable();
        let numericOids = this.oidDB.getChildrenOids(oids);
        const ont = this.deviceS.getOnt(ontSn);
        // oid.ifindex.ontId.EthernetPortId
        numericOids = numericOids.map(oid => oid + '.' + ont.ifIndex + '.' + ont.ontId + '.1');

        const ethSnmp = await this.snmpService.get(ont.oltId, numericOids);
        
        return {
            hwGponDeviceOntEthernetDuplexMode: ethSnmp[0].value,
            hwGponDeviceOntEthernetSpeed: ethSnmp[1].value,
            hwGponDeviceOntEthernetOnlineState: ethSnmp[2].value
        }
    }   
}
